import { themeSettings } from "../../js/settings";

let attributes = {
	block : null,
	isLoading: false,
	loadedAll: false,
	actionDelay: 500,
	query : {
		termCategories : [],
		featuredPostID : 0,
		paged : 1,
		s : ''
	},
	categories : null
}

/**
 * Set Attributes
 * @param {object} newProps
 */
const setAttributes = ( newProps ) => {

	attributes = { ...attributes, ...newProps };

}

/**
 * Blog Fetch
 *
 * @param {Object} block
 */
const blogFetch = ( block ) => {

	setAttributes( { block } );
	setfeaturedPost();
	categoryFilter();
	searchFilter();
	loadMore();

}

/**
 * Set featured Post
 *
 * @return {void}
 */
const setfeaturedPost = ( ) => {

	const { block, query } = attributes;
	const featuredPost = block.querySelector( '.js-blog-featured-post' );
	if ( ! featuredPost ) {

		return;

	}
	query.featuredPostID = featuredPost.dataset.postId;
	setAttributes( { query } );

}

/**
 * Load More
 *
 * @return {void}
 */
const loadMore = ( ) => {

	const { block, query } = attributes;
	const loadMoreBtn = block.querySelector( '.js-blog-load-more' );
	if ( ! loadMoreBtn ) {

		return;

	}
	loadMoreBtn.addEventListener( 'click', ( e ) => {

		e.preventDefault();
		updateQuery( query.paged +1 );

	} );

}

/**
 * Category Filter
 *
 * @return {void}
 */
const categoryFilter = ( ) => {

	const { block } = attributes;
	const categories = block.querySelectorAll( '.js-blog-tag' );
	setAttributes( { categories } );
	categories.forEach( ( category ) => {

		category.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			category.classList.toggle( 'is-active' );
			updateQuery( 1 );


		} );

	} );

}

/**
 * Search Filter
 *
 * @return {void}
 */
const searchFilter = ( ) => {

	const { block, query } = attributes;
	const search = block.querySelector( '.js-blog-search-input' );
	if ( ! search ) {

		return;

	}
	const infoText = block.querySelector( '.js-blog-info-text' );
	const searchClear = block.querySelector( '.js-blog-search-clear' );

	search.addEventListener( 'input', ( e ) => {

		query.s = e.target.value.replace( /(<([^>]+)>)/ig, '' );

		infoText.innerHTML = `${query.s}`;

		if ( query.s.length > 1 ) {

			updateQuery( 1 );

		}

		if ( query.s.length > 0 ) {

			block.classList.add( 'is-searching' );

		} else {

			block.classList.remove( 'is-searching' );

		}

	} );

	searchClear.addEventListener( 'click', ( e ) => {

		e.preventDefault();
		search.value = '';
		block.classList.remove( 'is-searching' );
		updateQuery( 1 );

	} );

}

/**
 * Update Layout
 *
 * @return {void}
 */
const updateLayout = () => {

	const { block, query } = attributes;
	if ( query.termCategories.length > 0 || query.s.length > 0 ) {

		block.classList.add( 'is-filtered' );

	} else {

		block.classList.remove( 'is-filtered' );

	}

}

/**
 * Update Query
 *
 * @param {number} paged
 * @return {void}
 */
const updateQuery = ( paged = 1 ) => {

	const { query, categories, isLoading, block } = attributes;
	if ( isLoading ) {

		return;

	}
	query.termCategories = [];
	query.s = block.querySelector( '.js-blog-search-input' ).value;

	categories.forEach( ( c ) => {

		if ( c.classList.contains( 'is-active' ) ) {

			query.termCategories = [...query.termCategories, c.dataset.catId];

		}

	} );
	query.paged = paged;
	setAttributes( { query } );
	updateLayout();
	fetchPosts();

}

/**
 * Fetch Posts
 * @return {void}
 */
const fetchPosts = debounce( () => {

	const { block, query, isLoading } = attributes;
	if ( isLoading ) {

		return;

	}
	setAttributes( { isLoading: true } );

	block.classList.add( 'is-loading' );
	const postsGrid = block.querySelector( '.js-blog-grid' );

	fetch( themeSettings.ajaxUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams( {
			action: 'getBlogPostsAjax',
			bn: themeSettings.security,
			featured_post_id: query.featuredPostID,
			term_categories: query.termCategories,
			search: query.s,
			paged: query.paged,
			posts_limit: 9,
		} ),
	} ).then( ( response ) => {

		return response.json();

	} ).then( ( response ) => {

		if ( query.paged === 1 || response.data.results === '' ) {

			postsGrid.innerHTML = '';

		}

		if ( response.data.results !== '' ) {

			postsGrid.insertAdjacentHTML( 'beforeend', response.data.results );

		}

		if ( response.data.lastPage ) {

			setAttributes( { loadedAll: true } );
			block.classList.add( 'is-loaded-all' );

		} else {

			block.classList.remove( 'is-loaded-all' );

		}
		block.classList.remove( 'is-loading' );
		setAttributes( { isLoading: false } );

	} ).catch( ( ) => {

		block.classList.remove( 'is-loading' );
		setAttributes( { isLoading: false } );

	} );


}, 500 );


/**
 * Debounce function
 *
 * @param {Function} func
 * @param {number} delay
 * @return {Function}
 */
function debounce( func, delay ) {

	let timeoutId;
	return ( ...args ) => {

		clearTimeout( timeoutId );
		timeoutId = setTimeout( () => {

			func.apply( this, args );

		}, delay );

	};

}


export default blogFetch;